export interface IBannerDetails {
	isEnabled: boolean;
	banners: IBanner[];
}

export interface IBanner {
	id?: string;
	name: string;
	message: string;
	link: string;
	pushMethod: 'Manual' | 'AtEnd';
	isEnabled?: boolean;
	isNewEntry?: boolean;
}

export const MAX_BANNERS = 7;
